import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_78bf8202 from 'nuxt_plugin_plugin_78bf8202' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_yandexmetrikaplugina15a565e_2f12400e from 'nuxt_plugin_yandexmetrikaplugina15a565e_2f12400e' // Source: ./yandex-metrika.plugin.a15a565e.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_10498fc0 from 'nuxt_plugin_cookieuniversalnuxt_10498fc0' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_02748123 from 'nuxt_plugin_pluginutils_02748123' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_254d5ca4 from 'nuxt_plugin_pluginrouting_254d5ca4' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_6a02a881 from 'nuxt_plugin_pluginmain_6a02a881' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_workbox_1b2bef34 from 'nuxt_plugin_workbox_1b2bef34' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_f9e67b72 from 'nuxt_plugin_metaplugin_f9e67b72' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_f097308a from 'nuxt_plugin_iconplugin_f097308a' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_axios_75a32018 from 'nuxt_plugin_axios_75a32018' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_bus_74525326 from 'nuxt_plugin_bus_74525326' // Source: ../src/plugins/bus.js (mode: 'all')
import nuxt_plugin_globalfunctions_a67001a0 from 'nuxt_plugin_globalfunctions_a67001a0' // Source: ../src/plugins/global-functions.js (mode: 'all')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../src/plugins/i18n.js (mode: 'all')
import nuxt_plugin_razletsulusdk_38eef5d8 from 'nuxt_plugin_razletsulusdk_38eef5d8' // Source: ../src/plugins/razlet-sulu-sdk.js (mode: 'all')
import nuxt_plugin_pwaupdate_81602bf6 from 'nuxt_plugin_pwaupdate_81602bf6' // Source: ../src/plugins/pwa-update.js (mode: 'client')
import nuxt_plugin_vueclickaway_63582e1e from 'nuxt_plugin_vueclickaway_63582e1e' // Source: ../src/plugins/vue-clickaway.js (mode: 'client')
import nuxt_plugin_vuelidate_4be431c8 from 'nuxt_plugin_vuelidate_4be431c8' // Source: ../src/plugins/vuelidate.js (mode: 'client')
import nuxt_plugin_forcenexttick_7c736810 from 'nuxt_plugin_forcenexttick_7c736810' // Source: ../src/plugins/force-next-tick.js (mode: 'client')
import nuxt_plugin_affiliator_3f257b34 from 'nuxt_plugin_affiliator_3f257b34' // Source: ../src/plugins/affiliator.js (mode: 'client')
import nuxt_plugin_emrldcoclient_4f456f56 from 'nuxt_plugin_emrldcoclient_4f456f56' // Source: ../src/plugins/emrldco.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Авиабилеты на рейсы авиакомпании \"ЯМАЛ\"","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"name":"mobile-web-app-capable","content":"yes"},{"name":"apple-touch-fullscreen","content":"yes"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"default"},{"name":"keywords","hid":"keywords","content":"авиакомпания, ямал, yamal"},{"name":"yandex-verification","content":"14d2debe1ff85085"}],"link":[{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon.png"},{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon-32x32.png","sizes":"32x32"},{"rel":"dns-prefetch","href":"https:\u002F\u002Faff2.razlet.ru"},{"rel":"apple-touch-icon","href":"apple-icon-180.png"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-2048-2732.jpg","media":"(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-2732-2048.jpg","media":"(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-1668-2388.jpg","media":"(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-2388-1668.jpg","media":"(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-1536-2048.jpg","media":"(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-2048-1536.jpg","media":"(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-1668-2224.jpg","media":"(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-2224-1668.jpg","media":"(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-1620-2160.jpg","media":"(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-2160-1620.jpg","media":"(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-1284-2778.jpg","media":"(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-2778-1284.jpg","media":"(device-width: 428px) and (device-height: 926px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-1170-2532.jpg","media":"(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-2532-1170.jpg","media":"(device-width: 390px) and (device-height: 844px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-1125-2436.jpg","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-2436-1125.jpg","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-1242-2688.jpg","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-2688-1242.jpg","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-828-1792.jpg","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-1792-828.jpg","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-1242-2208.jpg","media":"(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-2208-1242.jpg","media":"(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-750-1334.jpg","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-1334-750.jpg","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-640-1136.jpg","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"},{"rel":"apple-touch-startup-image","href":"icons\u002Fapple-splash-1136-640.jpg","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"},{"href":"https:\u002F\u002Fmc.yandex.ru\u002Fmetrika\u002Ftag.js","rel":"preload","as":"script"}],"script":[{"hid":"tpwgts-widget","nowprocket":"","data-noptimize":"1","data-cfasync":"false","data-wpfc-render":"false","seraph-accel-crit":"1","data-no-defer":"1","innerHTML":"(function() {\n          var script = document.createElement(\"script\");\n          script.async = 1;\n          script.type = \"module\";\n          script.src = \"https:\u002F\u002Ftpwgts.com\u002Fwl_web\u002Fmain.js?wl_id=23669\";\n          document.head.appendChild(script);\n        })();"}],"__dangerouslyDisableSanitizersByTagID":{"tpwgts-widget":["innerHTML"]},"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_78bf8202 === 'function') {
    await nuxt_plugin_plugin_78bf8202(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_yandexmetrikaplugina15a565e_2f12400e === 'function') {
    await nuxt_plugin_yandexmetrikaplugina15a565e_2f12400e(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_10498fc0 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_10498fc0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_02748123 === 'function') {
    await nuxt_plugin_pluginutils_02748123(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_254d5ca4 === 'function') {
    await nuxt_plugin_pluginrouting_254d5ca4(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_6a02a881 === 'function') {
    await nuxt_plugin_pluginmain_6a02a881(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_1b2bef34 === 'function') {
    await nuxt_plugin_workbox_1b2bef34(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_f9e67b72 === 'function') {
    await nuxt_plugin_metaplugin_f9e67b72(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_f097308a === 'function') {
    await nuxt_plugin_iconplugin_f097308a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_75a32018 === 'function') {
    await nuxt_plugin_axios_75a32018(app.context, inject)
  }

  if (typeof nuxt_plugin_bus_74525326 === 'function') {
    await nuxt_plugin_bus_74525326(app.context, inject)
  }

  if (typeof nuxt_plugin_globalfunctions_a67001a0 === 'function') {
    await nuxt_plugin_globalfunctions_a67001a0(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba523a === 'function') {
    await nuxt_plugin_i18n_1fba523a(app.context, inject)
  }

  if (typeof nuxt_plugin_razletsulusdk_38eef5d8 === 'function') {
    await nuxt_plugin_razletsulusdk_38eef5d8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pwaupdate_81602bf6 === 'function') {
    await nuxt_plugin_pwaupdate_81602bf6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueclickaway_63582e1e === 'function') {
    await nuxt_plugin_vueclickaway_63582e1e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelidate_4be431c8 === 'function') {
    await nuxt_plugin_vuelidate_4be431c8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_forcenexttick_7c736810 === 'function') {
    await nuxt_plugin_forcenexttick_7c736810(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_affiliator_3f257b34 === 'function') {
    await nuxt_plugin_affiliator_3f257b34(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_emrldcoclient_4f456f56 === 'function') {
    await nuxt_plugin_emrldcoclient_4f456f56(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
